import PropTypes from "prop-types";

import { defineMessages, injectIntl, FormattedMessage } from "react-intl";

import ImmutablePropTypes from "react-immutable-proptypes";
import ImmutablePureComponent from "react-immutable-pure-component";
import { connect } from "react-redux";

import { debounce } from "lodash";

import { fetchBlocks, expandBlocks } from "flavours/glitch/actions/blocks";
import ColumnHeader from "flavours/glitch/components/column_header";
import PageFrame from "flavours/glitch/features/ui/components/page_frame";
import { LoadingIndicator } from "flavours/glitch/components/loading_indicator";
import AccountContainer from "flavours/glitch/containers/account_container";

import ScrollableList from "../../components/scrollable_list";

const messages = defineMessages({
  heading: { id: "column.blocks", defaultMessage: "Blocked users" },
});

const mapStateToProps = state => ({
  accountIds: state.getIn(["user_lists", "blocks", "items"]),
  hasMore: !!state.getIn(["user_lists", "blocks", "next"]),
  isLoading: state.getIn(["user_lists", "blocks", "isLoading"], true),
});

class Blocks extends ImmutablePureComponent {

  static propTypes = {
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    accountIds: ImmutablePropTypes.list,
    hasMore: PropTypes.bool,
    isLoading: PropTypes.bool,
    intl: PropTypes.object.isRequired,
    multiColumn: PropTypes.bool,
    embedded: PropTypes.bool,
  };

  UNSAFE_componentWillMount () {
    this.props.dispatch(fetchBlocks());
  }

  handleLoadMore = debounce(() => {
    this.props.dispatch(expandBlocks());
  }, 300, { leading: true });

  render () {
    const { intl, accountIds, hasMore, multiColumn, embedded, isLoading } = this.props;
    const title = intl.formatMessage(messages.heading);

    if (!accountIds) {
      return (
        <PageFrame embedded={embedded}>
          <LoadingIndicator />
        </PageFrame>
      );
    }

    const emptyMessage = <FormattedMessage id='empty_column.blocks' defaultMessage="You haven't blocked any users yet." />;

    return (
      <PageFrame embedded={embedded} bindToDocument={!multiColumn} label={title}>
        <ColumnHeader icon='prohibit' title={title} multiColumn={multiColumn} showBackButton />
        <ScrollableList
          scrollKey='blocks'
          onLoadMore={this.handleLoadMore}
          hasMore={hasMore}
          isLoading={isLoading}
          emptyMessage={emptyMessage}
          bindToDocument={!multiColumn && !embedded}
        >
          {accountIds.map(id =>
            <AccountContainer key={id} id={id} defaultAction='block' />,
          )}
        </ScrollableList>
      </PageFrame>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(Blocks));
